module.exports = __webpack_public_path__ + "static/media/HCMM214.7c210af7.jpg";